import { addDoc, collection, serverTimestamp } from 'firebase/firestore';
import { auth, db } from './firebase';

/**
 * Ki-mit-mikor napló.
 *
 * - Minden feladat-írásra a kliens rápecsételi a szerkesztőt (`actorStamp()`), a Cloud Function
 *   (`functions/audit.js`) pedig a régi/új állapot különbségét beírja az `auditLog` kollekcióba.
 * - Belépés / kilépés: a kliens írja közvetlenül (`logAuth`).
 */

/** A bejelentkezett felhasználó pecsétje egy dokumentum-frissítéshez. */
export const actorStamp = () => {
  const u = auth.currentUser;
  return {
    updatedAt: serverTimestamp(),
    updatedBy: u?.uid || null,
    updatedByName: u?.displayName || u?.email || null
  };
};

export type AuditAuthAction = 'login' | 'logout' | 'login_failed';

/** Belépés / kilépés naplózása (nem dob hibát). */
export async function logAuth(action: AuditAuthAction, extra?: { organizationId?: string | null; email?: string | null; method?: string }) {
  try {
    const u = auth.currentUser;
    await addDoc(collection(db, 'auditLog'), {
      entity: 'auth',
      action,
      actorId: u?.uid || null,
      actorName: u?.displayName || u?.email || extra?.email || null,
      organizationId: extra?.organizationId || null,
      entityId: u?.uid || null,
      entityLabel: extra?.email || u?.email || null,
      changes: [],
      meta: { method: extra?.method || null, userAgent: typeof navigator !== 'undefined' ? navigator.userAgent.slice(0, 200) : null, screen: typeof window !== 'undefined' ? `${window.screen?.width}x${window.screen?.height}` : null },
      at: serverTimestamp()
    });
  } catch (e) {
    console.warn('auditLog write failed', e);
  }
}
